import React, { type ReactNode } from 'react'

function YoutubeLogoIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      fill="var(--color-icon-social)"
      xmlns="http://www.w3.org/2000/svg"
      id="body_1"
      width="31"
      height="22"
      {...props}
    >
      <defs>
        <clipPath id="1">
          <path clipRule="evenodd" d="M0 0L122.88 0L122.88 86.43L0 86.43z" />
        </clipPath>
      </defs>

      <g transform="matrix(0.25227866 0 0 0.25227866 -0 0.09777742)">
        <g clipPath="url(#1)">
          <path
            transform="matrix(1 0 0 1 -12198 8410)"
            d="M12259.441 -8323.52C 12258.131 -8323.531 12227.25 -8323.825 12217.662 -8324.741C 12217.186 -8324.831 12216.62 -8324.899 12215.962 -8324.979C 12212.776 -8325.363 12207.962 -8325.944 12204.088 -8330.001C 12202.1875 -8331.949 12200.969 -8335.173 12200.276 -8337.534C 12199.823 -8339.078 12199.47 -8340.649 12199.218 -8342.239C 12198.463 -8348.847 12198.057 -8355.489 12198 -8362.14L12198 -8362.14L12198 -8371.45C 12198.053 -8378.101 12198.46 -8384.743 12199.218 -8391.351C 12199.466 -8392.939 12199.819 -8394.51 12200.273 -8396.051C 12200.967 -8398.407 12202.197 -8401.62 12204.119 -8403.542C 12205.872 -8405.405 12208.049 -8406.818 12210.465 -8407.661C 12212.138 -8408.206 12213.872 -8408.544 12215.629 -8408.668L12215.629 -8408.668L12215.684 -8408.674C 12215.951 -8408.699 12216.205 -8408.725 12216.429 -8408.752C 12233.436 -8409.987 12259.17 -8410.002 12259.429 -8410.002C 12259.6875 -8410.002 12285.429 -8409.987 12302.419 -8408.752C 12302.625 -8408.728 12302.869 -8408.702 12303.21 -8408.669C 12304.969 -8408.544 12306.705 -8408.205 12308.382 -8407.66C 12310.799 -8406.818 12312.977 -8405.406 12314.731 -8403.542C 12316.642 -8401.62 12317.872 -8398.407 12318.567 -8396.051C 12319.023 -8394.51 12319.379 -8392.939 12319.631 -8391.351L12319.631 -8391.351L12319.621 -8391.363C 12320.384 -8384.756 12320.802 -8378.114 12320.871 -8371.463L12320.871 -8371.463L12320.871 -8362.104C 12320.816 -8355.453 12320.409 -8348.811 12319.652 -8342.203C 12319.399 -8340.616 12319.045 -8339.046 12318.591 -8337.503C 12317.896 -8335.145 12316.668 -8331.93 12314.761 -8330.009C 12313.005 -8328.1455 12310.826 -8326.732 12308.408 -8325.89C 12306.732 -8325.344 12304.996 -8325.006 12303.238 -8324.882C 12302.901 -8324.85 12302.649 -8324.823 12302.438 -8324.799C 12285.466 -8323.534 12259.7 -8323.52 12259.441 -8323.52zM12246.711 -8385.369L12246.711 -8350.839L12279.899 -8368.05L12246.711 -8385.369z"
            stroke="none"
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  )
}

export default YoutubeLogoIcon
